import cn from 'classnames';
import { ReactSVG } from 'react-svg';

interface AssetIconV2Props {
  icon: string;
  product: string;
  inverted?: boolean;
  classNames?: string;
  roundedCorners?: boolean;
  defaultIcon?: string;
}

export const AssetIconV2 = ({
  icon,
  classNames,
  defaultIcon,
}: AssetIconV2Props) => {
  const iconName = icon || defaultIcon || 'clip';

  return (
    <ReactSVG
      className={cn('AssetIconV2', iconName, {
        ...(classNames && { [classNames]: true }),
      })}
      src={`/public/img/${iconName}.svg`}
    />
  );
};

export default AssetIconV2;
